const types = {
  USER_INFO: "USER_INFO",
  LANG_INFO: "LANG_INFO",
  REMOVE_USER_INFO: "REMOVE_USER_INFO",
  SET_TYPE_TIME: "SET_TYPE_TIME",
  SET_LOADING: "SET_LOADING"
};

export default types;
